<template>
  <div id="app">
    <top-nav></top-nav>
    <div class="main-body">
      <keep-alive>
        <router-view/>
      </keep-alive>
    </div>
    <footer-nav></footer-nav>
  </div>
</template>
<script>
import Top from './components/top'
import Footer from './components/footer'
export default {
  components: {
    'top-nav': Top,
    'footer-nav': Footer
  }
}
</script>
<style lang="scss">
@import '@/assets/style/vars.scss';
body {
  background-color: #fff;
}
#app {
  font-family: $fontFamily;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #333;
}
.main-body {
  min-height: calc(100vh - 360px)
}
</style>
